import { useQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";
import { currencyQuery } from "../utils/query";
import { getWhiteLabel } from "../utils/white-label";

type UseCurrencyOutput = {
  currency: string;
};

export const useCurrency = (): UseCurrencyOutput => {
  const { currency: defaultCurrency } = getWhiteLabel();
  const search = useSearch({
    strict: false,
  });

  const hasCurrency = "currency" in search;

  const userCurrencyQuery = useQuery({
    queryKey: ["userCurrency"],
    queryFn: () => currencyQuery.getCurrencyCodeByIp(),
    enabled: !hasCurrency,
  });

  return {
    currency: hasCurrency
      ? (search.currency as string)
      : userCurrencyQuery.data || defaultCurrency,
  };
};
